<ng-container *transloco="let t">
  <main>
    <h3 class="main-title">פרטי מתכנן</h3>

    <section *ngIf="!(readonly || printPreview)">
      <nz-space>
        <ng-template nzSpaceItem>
          <button mat-raised-button color="accent" (click)="selectPlanner()">
            בחר מתכנן
          </button>
        </ng-template>
        <ng-template nzSpaceItem>
          <button mat-raised-button color="accent" (click)="newPlanner()">
            הוסף מתכנן חדש
          </button>
        </ng-template>
        <ng-template nzSpaceItem></ng-template>
      </nz-space>
    </section>
    <br />

    <section>
      <mat-form-field floatLabel="always">
        <mat-label>שם</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('name') }}"
          [(ngModel)]="planner.name"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>טלפון</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('phone') }}"
          [(ngModel)]="planner.phone"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>מייל</mat-label>
        <input
          type="text"
          name="email"
          matInput
          placeholder="{{ t('email') }}"
          [(ngModel)]="planner.email"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>כתובת</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('address') }}"
          [(ngModel)]="planner.address"
          readonly
        />
      </mat-form-field>

      <mat-form-field floatLabel="always">
        <mat-label>שם המשרד</mat-label>
        <input
          type="text"
          matInput
          placeholder="{{ t('officeName') }}"
          [(ngModel)]="planner.officeName"
          readonly
        />
      </mat-form-field>

      <button
        mat-raised-button
        color="accent"
        (click)="editPlanner()"
        *ngIf="!(readonly || printPreview)"
      >
        עריכה
      </button>
    </section>
  </main>
</ng-container>
